export * from './src/restaurants-menus-v1-item-label-item-labels.context.js';
